import { createSlice } from "@reduxjs/toolkit";

export const instituteInformation = createSlice({
    name:"instituteInformation",
    initialState:{
        instituteInformation:JSON.parse(window.localStorage.getItem('instituteInformation')) || null
    },
    reducers:{
        informationInstitute: (state,action)=>{
            window.localStorage.setItem('instituteInformation',JSON.stringify(action.payload));
            let instituteInformation = JSON.parse(window.localStorage.getItem('instituteInformation'));
            state.instituteInformation = instituteInformation ;
        },
        removeInstituteInformation: (state) => {
        window.localStorage.removeItem('instituteInformation');
        state.instituteInformation=null;
        console.log('okey remove institute information');
        },
    }
})

export const { informationInstitute,removeInstituteInformation } = instituteInformation.actions;

export const selectInstituteInformation = state => state.instituteInformation.instituteInformation;

export default instituteInformation.reducer;